import insightMixin from '@/mixins/insights';

export default {
  mixins: [insightMixin],
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    classModifiers() {
      return {
        'insight-widget': true,
        [`insight-widget--${this.theme}`]: this.theme,
      };
    },
  },
};
